import styled from 'styled-components';
// @ts-ignore
import { FONTS, COLORS } from '@ertelecom/ui-react/assets/js/constants';
// @ts-ignore
import InputSimple, { phoneDecorator, nameDecorator } from '@ertelecom/ui-react/components/inputSimple';
import StyledButton from '@ertelecom/ui-react/components/buttons/styledButton/styledButton';
import Throbber from '@ertelecom/ui-react/components/throbber/throbber';

const InputPhone = phoneDecorator(InputSimple);
const InputName = nameDecorator(InputSimple);

const breakePoints = {
    sDesktop: '1187px',
    tablet: '859px',
    mobile: '640px',
};

export const StyledThrobber = styled(Throbber)`
    position: absolute;
`;

export const RequestFormWrapper = styled.div`
    position: relative;
    dispaly: flex;
    flex-direction: column;
    max-width: 780px;
`;

export const Inputs = styled.div<{ isVertical: boolean | undefined }>`
    display: flex;
    flex-direction: ${p => p.isVertical ? 'column' : 'row'};
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    min-height: 75px;
    
    @media (max-width: ${breakePoints.mobile}) {
        flex-wrap: wrap;
    }
`;

export const Name = styled(InputName)`
    flex: 1 1 100%;
    width: 100%;
    margin-right: ${p => p.isVertical ? '0' : '16px'};

    @media (max-width: ${breakePoints.mobile}) {
        margin-right: 0;
    }
`;

export const Phone = styled(InputPhone)`
    flex: 1 1 100%;
    width: 100%;
`;

export const ButtonBlock = styled.div<{ isVertical: boolean | undefined }>`
    display: flex;
    flex-direction: ${p => p.isVertical ? 'column' : 'row'};
    flex-wrap: nowrap;
    align-items: ${p => p.isVertical ? 'flex-start' : 'center'};
    width: 100%;

    @media (max-width: ${breakePoints.mobile}) {
        flex-wrap: wrap;
    }
`;

interface ButtonProps {
    isVertical?: boolean
}

export const Button = styled(StyledButton)<ButtonProps>`
    width: auto;
    min-width: 236px;
    margin-right: ${p => p.isVertical ? '0' : '21px'};
    margin-bottom: ${p => p.isVertical ? '15px' : '0'};

    @media (max-width: ${breakePoints.mobile}) {
        margin-bottom: 15px;
        margin-right: 0;
    }
`;

export const Agree = styled.span`
    font-family: ${FONTS.light};
    font-size: 14px;
    line-height: 1.25;
    color: ${COLORS.darkGrey};
`;

export const AgreeLink = styled.a`
    margin-left: 5px;
    border-bottom: 1px solid ${COLORS.darkGrey};
    color: ${COLORS.darkGrey};
`;

export const Message = styled.div<{ ok: boolean | undefined }>`
    margin-top: 10px;
    width: 100%;
    min-height: 16px;
    color: ${p => p.ok ? COLORS.green : COLORS.red};
    font-size: 16px;
`;

